/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Document_File_Not_In_ProjectInputs */

const es_co2_error_document_file_not_in_project = /** @type {(inputs: Error_Document_File_Not_In_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El archivo no pertenece a este proyecto. Súbelo de nuevo.`)
};

/**

* @param {Error_Document_File_Not_In_ProjectInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_document_file_not_in_project = /** @type {((inputs?: Error_Document_File_Not_In_ProjectInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Document_File_Not_In_ProjectInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_document_file_not_in_project(inputs)
});